import axios from 'axios';
import { getPortalServerIp } from '../storage';
const api = axios.create({
  baseURL: getPortalServerIp(),
});

export default api;
